import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// import Alert from '@mui/material/Alert';
import Chip from '@mui/material/Chip';
import Switch from '@mui/material/Switch';
// import Select from '@mui/material/Select';
// import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BtnGradient from 'src/components/common/button/BtnGradient';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import PatientIcons from 'src/components/common/patients/PatientIcons';
import DialogRegisterAlert from './dialog/DialogRegisterAlert';

const Information = (props: any) => {
  const patient = props.patient;
  const navigate = useNavigate();
  const [openRegisterAlert, setOpenRegisterAlert] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.handleChangeLayout(event.target.checked);
  };

  // const handlePatientDetailChange = () => {};
  // const handleTagSearchChange = () => {};
  const handleToDetail = () => {
    navigate(`/patient/detail?id=${patient?.id}`);
  };
  const handleOpenQuestionClick = () => {
    navigate(`/patient/answers?id=${patient?.id}`);
  };

  const handleRegisterAlert = () => {
    setOpenRegisterAlert(true);
  };

  const handleCloseDialogRegisterAlert = () => {
    setOpenRegisterAlert(false);
  };

  return (
    <Stack width={'100%'}>
      <Stack
        p={'16px 24px'}
        borderRadius={'4px'}
        sx={{ backgroundColor: 'primary.light' }}
        mb={'16px'}
      >
        <Stack direction='row' justifyContent={'space-between'}>
          <Stack direction='row' spacing={'16px'}>
            {/* <Alert
            severity='error'
            sx={{ flex: 1, py: 0, border: '1px solid #DA4453' }}
            action={
              <Box
                component={'img'}
                src='/images/ic-arrow-right-gray.svg'
                alt='edit'
                sx={{ cursor: 'pointer' }}
              />
            }
          >
            名前と電話番号が重複しています
          </Alert> */}
            <Box
              component={'img'}
              src='/images/icons/ic-edit.svg'
              alt='edit'
              sx={{ cursor: 'pointer', width: '24px' }}
              onClick={handleToDetail}
            />
            <Box sx={{ position: 'relative' }}>
              <BtnOutlineGradient
                text='WEB問診票を開く'
                handleButtonClick={handleOpenQuestionClick}
                width='120px'
              />
              <Box
                sx={{
                  position: 'absolute',
                  top: '38px',
                  backgroundColor: '#f0f0f0',
                  padding: 0,
                  borderRadius: 2,
                  width: '150px',
                  height: 20,
                  textAlign: 'center',
                  '::before': {
                    content: '""',
                    position: 'absolute',
                    top: '-6px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: 0,
                    height: 0,
                    borderLeft: '6px solid transparent',
                    borderRight: '6px solid transparent',
                    borderBottom: '6px solid #f0f0f0',
                  },
                }}
              >
                <Typography fontSize={12}>
                  最終更新日: {patient?.answer_last_change_date}
                </Typography>
              </Box>
            </Box>
            <BtnGradient
              text={`アラート登録${patient?.alert ? '*' : ''}`}
              width='110px'
              handleButtonClick={handleRegisterAlert}
            />
          </Stack>
          <Switch
            checked={props.layoutFull}
            onChange={handleChange}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        </Stack>
        <Stack direction='row' spacing={'20px'} mt={'12px'}>
          <Stack minWidth={'300px'} justifyContent={'space-between'}>
            <Stack>
              <Stack direction={'row'} spacing={'16px'} my={'16px'}>
                <Box
                  component={'img'}
                  src='/images/icons/draw/ic-gender-women.svg'
                  alt='ic-note'
                  width={'32px'}
                />
                <Stack>
                  <Typography fontWeight={500} color={'#656D78'}>
                    {patient?.kana || ''}
                  </Typography>
                  <Typography
                    fontSize={'20px'}
                    fontWeight={500}
                    color={'#434154'}
                  >
                    {patient?.fullname || ''}
                  </Typography>
                </Stack>
              </Stack>
              <Stack direction={'row'} flexWrap={'wrap'}>
                {(patient?.salon_no || patient?.salon_no === '退会済み') ?? (
                  <Chip
                    label='サロンメンバー'
                    sx={{
                      borderRadius: '4px',
                      color: '#4FC1E9',
                      border: '1px solid #4FC1E9',
                      fontSize: '10px',
                      height: '21px',
                      mr: '8px',
                      mb: '8px',
                    }}
                    variant='outlined'
                  />
                )}
                {/* Hide unuse menu as of now */}
                {/* <Chip
                  label='スタッフ'
                  sx={{
                    borderRadius: '4px',
                    color: '#37BC9B',
                    border: '1px solid #37BC9B',
                    fontSize: '10px',
                    height: '21px',
                    mr: '8px',
                    mb: '8px',
                  }}
                  variant='outlined'
                />
                <Chip
                  label='アレルギー・既往歴あり'
                  sx={{
                    borderRadius: '4px',
                    color: '#FC6E51',
                    border: '1px solid #FC6E51',
                    fontSize: '10px',
                    height: '21px',
                    mr: '8px',
                    mb: '8px',
                  }}
                  variant='outlined'
                /> */}
              </Stack>
            </Stack>
            <PatientIcons patient={patient} />
          </Stack>
          <Stack width={'100%'} spacing={'12px'}>
            <Stack p={'12px'} spacing={'4px'} sx={{ bgcolor: '#F5F8FE' }}>
              <Stack>
                <Typography fontWeight={700} mb={'12px'}>
                  患者詳細
                </Typography>
              </Stack>
              <Stack direction={'row'}>
                <Stack width={'20%'} spacing={'4px'}>
                  <Typography>生年月日</Typography>
                  <Typography fontWeight={500}>{patient?.dob || ''}</Typography>
                </Stack>
                <Stack width={'40%'} spacing={'4px'}>
                  <Typography>電話</Typography>
                  <Typography fontWeight={500}>
                    {patient?.phone || ''}
                  </Typography>
                </Stack>
                <Stack width={'40%'} spacing={'4px'}>
                  <Typography>郵便番号</Typography>
                  <Typography fontWeight={500}>
                    {patient?.postcode || ''}
                  </Typography>
                </Stack>
              </Stack>
              <Stack direction={'row'}>
                <Stack width={'20%'} spacing={'4px'}>
                  <Typography>年齢</Typography>
                  <Typography fontWeight={500}>{patient?.age || ''}</Typography>
                </Stack>
                <Stack width={'40%'} spacing={'4px'}>
                  <Typography>メールアドレス</Typography>
                  <Box fontWeight={500}>
                    {patient?.email
                      .split(',')
                      .map((em: string, index: number) => {
                        return <Typography key={index}>{em}</Typography>;
                      })}
                  </Box>
                </Stack>
                <Stack width={'40%'} spacing={'4px'}>
                  <Typography>住所</Typography>
                  <Typography fontWeight={500}>
                    {patient?.address || ''}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <TextField
              id='outlined-multiline-static'
              label=''
              multiline
              rows={3}
              defaultValue={patient?.private_note}
              InputProps={{
                sx: { fontSize: '14px', maxWidth: '100%' },
              }}
            />
          </Stack>
        </Stack>
      </Stack>
      {/* Hide unuse menu as of now */}
      {/* <Stack mb={'16px'}>
        <Select
          className='select-status'
          value={'タグ検索'}
          onChange={handleTagSearchChange}
          sx={{
            '& .MuiSelect-select.MuiSelect-outlined': {
              py: '13px',
            },
            backgroundColor: 'primary.light',
          }}
        >
          <MenuItem value={'タグ検索'}>タグ検索</MenuItem>
        </Select>
      </Stack> */}

      <DialogRegisterAlert
        open={openRegisterAlert}
        onClose={handleCloseDialogRegisterAlert}
        patientid={patient?.id || 0}
        textAlert={patient?.alert || ''}
      />
    </Stack>
  );
};

export default Information;
